<template>
  <BaseNode v-bind="props">
    <template #header>
      <BaseHtmlContent class="node__title" :html="processText(node.question, decisionTree.context)" />
    </template>
    <template #body>
      <BaseSelect v-model="selectedVisitTypeId" :options="options" :test-id="TestId.booking.visitType"></BaseSelect>
      <BaseHtmlContent v-if="selectedVisitType?.help" class="visit-type-help" :html="selectedVisitType.help" />
    </template>
  </BaseNode>
</template>

<script setup>
import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";
import { TestId } from "#/test-ids";

import { computed } from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const filteredVisitTypes = computed(() => props.node.filteredVisitTypes(props.decisionTree.context));

const options = computed(() =>
  filteredVisitTypes.value.map((visitType) => ({
    label: visitType.name,
    value: visitType.id.toString(),
  })),
);

const selectedVisitTypeId = computed({
  get() {
    return props.node.selectedVisitTypeId?.toString();
  },
  set(idString) {
    props.node.selectedVisitTypeId = idString ? Number(idString) : undefined;
  },
});

const selectedVisitType = computed(() => {
  if (!selectedVisitTypeId.value) {
    return null;
  }
  return filteredVisitTypes.value.find((v) => v.id === Number(selectedVisitTypeId.value));
});

const { processText } = useSnippetProcessor();
</script>

<style scoped lang="scss">
.visit-type-help {
  margin-top: 1rem;
}
</style>
